import {Injectable} from '@angular/core';
import {HttpParams} from '@angular/common/http';

import {APrHabilitation} from './DonneesPermissions';
import {ValAppSettingsService} from '../../../../val-ammon-services/val-app-settings-lib/src/public-api';
import {ValApiResultat, ValBaseService} from '../../../../val-ammon-services/val-services-communs-lib/src/public-api';

//Services permissions
@Injectable (
{
  providedIn: 'root'
})
export class PermissionsService extends ValBaseService 
{
  //Création
  //  Paramètres
  //    appSettingsService : Service d’accès à la configuration de l’application
  //    httpClient         : Client HTTP
  constructor (private appSettingsService: ValAppSettingsService) 
  {
    super ();
  }

  //Url de base
  protected override get BaseUrl () : string 
  {
    return this.appSettingsService.Configuration.UrlApi.Permissions;
  }

  //Retourne les habilitations de l’utilisateur connecté
  //  Paramètres
  //    identifiantsDicos : Identifiants des dicos
  //  Retourne
  //    Résultat de la récupération des habilitations de l’utilisateur connecté
  public async RetournerHabilitations (identifiantsDicos: string[]) : Promise<ValApiResultat<APrHabilitation[]>> 
  {
    let operation: Promise<ValApiResultat<APrHabilitation[]>>;
    let parametres: HttpParams;

    parametres = new HttpParams (
    {
      fromObject:
      {
        IdentifiantsDicos: identifiantsDicos.map (String)
      }
    });

    operation = this.ExecuterRequeteGet<APrHabilitation[]> ("/v1.0/user/habilitations", parametres);

    return operation;
  }
}
